import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { BRAND, scrollToId } from "@/lib/site";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
  </svg>
);

const socials = [
  { key: "facebook", label: "Facebook", Icon: Facebook },
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "youtube", label: "YouTube", Icon: Youtube },
  { key: "whatsapp", label: "WhatsApp", Icon: WhatsAppIcon },
];

export const Footer = () => (
  <footer className="bg-muted text-foreground pt-16 pb-8 border-t border-black/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-black/10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="alfabrains logo" className="h-14 w-14 object-contain" />
            <div>
              <span className="font-heading font-black text-2xl text-primary">alfa</span>
              <span className="font-heading font-black text-2xl text-secondary">brains</span>
              <div className="font-label text-[10px] tracking-[0.25em] uppercase text-muted-foreground">Online Tutoring</div>
            </div>
          </div>
          <p className="text-muted-foreground mt-5 max-w-sm leading-relaxed">Personalised online tutoring for Grades 1 to 8, matched to your child's grade, board and syllabus.</p>
          <div className="flex items-center gap-3 mt-6" data-testid="footer-socials">
            {socials.map(({ key, label, Icon }) => (
              <a key={key} href={BRAND.social[key]} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`social-${key}`}
                className="h-10 w-10 rounded-full bg-white border border-black/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white hover:-translate-y-0.5 transition-[transform,background-color,color] duration-200">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-heading font-bold text-lg mb-4 text-primary">Explore</h4>
          <ul className="space-y-2.5 text-muted-foreground">
            {[["How it Works", "#how"], ["Plans", "#plans"], ["Courses", "#courses"], ["FAQ", "#faq"]].map(([l, h]) => (
              <li key={h}><button onClick={() => scrollToId(h)} className="hover:text-secondary transition-colors">{l}</button></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-heading font-bold text-lg mb-4 text-primary">Get in touch</h4>
          <ul className="space-y-3 text-muted-foreground">
            <li className="flex items-center gap-3"><Mail size={18} className="text-secondary" /> {BRAND.email}</li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-secondary" /> {BRAND.phone}</li>
            <li className="flex items-center gap-3"><MapPin size={18} className="text-secondary" /> India · Online</li>
          </ul>
        </div>
      </div>
      <div className="pt-6 flex flex-col sm:flex-row justify-between gap-3 text-sm text-muted-foreground">
        <span>© {new Date().getFullYear()} alfabrains Online Tutoring. All rights reserved.</span>
        <span>Made with care for curious minds.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
